import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { LOAD_TRANSFORMERS } from '../transformers';
import { useEffect } from 'react';
import { $convertFromMarkdownString } from '@lexical/markdown';
import { getSummaryForViewMode } from '../../../Attachments/InlineAttachment';

import { useImpressionEditorContext } from '../../Context';

export const MarkdownChangePlugin = () => {
  const { activeImpression, viewMode } = useImpressionEditorContext();
  const [editor] = useLexicalComposerContext();

  const editorContent =
    activeImpression?.reviewDiffDocument ?? activeImpression?.summary ?? '';

  useEffect(() => {
    editor.update(() => {
      $convertFromMarkdownString(
        getSummaryForViewMode(editorContent, viewMode),
        LOAD_TRANSFORMERS,
      );
    });
  }, [editorContent, editor, viewMode]);

  return null;
};
